'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Get the first 5 suggestions that match
var defaultSuggestionsFilter = function defaultSuggestionsFilter(searchValue, suggestions, maxSize) {
  maxSize = maxSize || 5;
  var value = searchValue.toLowerCase();
  var filteredSuggestions = suggestions.filter(function (suggestion) {
    return !value || suggestion.get('name').toLowerCase().indexOf(value) > -1;
  });
  var size = filteredSuggestions.size < maxSize ? filteredSuggestions.size : maxSize;
  return filteredSuggestions.setSize(size);
};

exports.default = defaultSuggestionsFilter;



//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/draft-js-mention-plugin/utils/defaultSuggestionsFilter.js
// module id = 619
// module chunks = 0